import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useCallback } from 'react';

import type { PlacementRenderProps } from '@post-office/browser--people-and-teams/teams-app-changeboarding';

import { type MessageTemplateContext } from '../../..';

import { type JSX } from 'react/jsx-runtime';

type RenderProps = PlacementRenderProps & MessageTemplateContext;

export const MessageComponent = ({ children, dismiss }: RenderProps): JSX.Element => {
	const { onClosed } = usePostOfficeUserInteractions();
	const handleDismiss = useCallback(() => {
		dismiss();
		void onClosed({
			interactionIdentifier: 'dismiss',
		});
	}, [onClosed, dismiss]);

	return <>{children?.(handleDismiss)}</>;
};
